import { isMobile } from 'react-device-detect';
import { ImageWithDefault } from "./ImageWithDefault";
import "../styles/rule-item.scss";

export const RuleItem = (props) => {

    const { data } = props;

    return (
        <div className='rule-item' {...props}>
            <div className="rule-item__image-container">
                <ImageWithDefault src={data?.image} className={!isMobile ? "rule-item__image" : ""} />
            </div>
            <p className='rule-item__title'>{data.title}</p>
        </div>
    )
}